@import "../../variables.scss";
$color-rejected-status: #d4403a;
$color-incomplete-status: #495057;
$color-pending-status: #4488ff;
$color-approved-status: #0ead0e;

.rldownload {
  &__agreement {
    padding-right: 0.5rem;
    padding-bottom: 0.5rem;
    width: 100%;
    &_custom {
      padding-right: 0.5rem;
      width: 100%;
    }
    &_customTitle {
      margin-left: 35px;
      display: block;
    }
  }
  &__multipleAgreements {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99;
    &_inner {
      background-color: white;
      padding: 1rem;
      border-radius: 16px;
      display: flex;
      flex-direction: column;
      width: 70%;
      max-height: 100vh;
      overflow-y: auto;
      align-items: center;
      @media (max-width: $size-sm) {
        width: 100%;
        border-radius: 0px;
      }
    }
  }
  &__wrapper {
    border-bottom: #d0d0d0 1px solid;
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    justify-content: flex-start;
    padding: 1rem;
    align-items: center;
	 @media (max-width: $size-xl) {
		flex-wrap: wrap;
      justify-content: flex-end;
      align-items: center;
    }
  }

  &__wrapper__reading {
    padding: 1rem;
    background-color: #f6f9ff;
    @media (max-width: $size-sm) {
      padding: 16px;
    }
  }

  &__wrapper__reading {
    span {
      flex-grow: 1;
    }
    input {
      margin-right: 10px;
    }
  }

  &__mobile_row {
    display: flex;
    flex-grow: 1;
    align-items: center;
	 @media (max-width: $size-lg) {
      margin-bottom: 8px;
    }
  }

  &__status {
    width: 93px;
    border: 2px solid;
    border-radius: 21px;
    text-transform: uppercase;
    text-align: center;
    padding: 7px 2px;
    font-family: Lato;
    font-size: 18px;
    letter-spacing: 0.34px;
    line-height: 22px;
    display: inline-block;
    font-weight: 700;
    margin-right: 1rem;
    height: 40px;
    flex-shrink: 0;
    @media (max-width: $size-md) {
      // order: 1;
      margin-right: 9px;
      margin-bottom: 8px;
      max-height: 40px;
    }
  }

  &__todo {
    background-color: rgba(217, 83, 79, 0.05);
    border-color: $color-rejected-status;
    color: $color-rejected-status;
  }

  &__done {
    background-color: rgba(14, 173, 14, 0.05);
    border-color: $color-approved-status;
    color: $color-approved-status;
  }

  &__pending {
    border-color: #2196f3;
    color: #2196f3;
  }

  &__title {
    flex-grow: 1;
    padding-right: 5px;
    font-weight: bold;
    @media (max-width: $size-md) {
      padding-bottom: 9px;
    }
  }

  &__message {
	color: #d4403a;
	font-size: 80%;
	@media (max-width: $size-md) {
		font-weight: normal!important;
	 }
 }

  &__message_important {
	color: #d4403a;
	padding-right: 15px;
	font-size: 80%;
	font-weight: bold;
	@media (max-width: $size-md) {
	  padding-bottom: 9px;
	}
	@media (max-width: $size-lg) {
		margin-right: auto;
	 }
 }




  &__description {
    color: $color-grey;
    width: 600px;

    @media (max-width: $size-lg) {
      width: 450px;
    }

    @media (max-width: $size-sm) {
      width: 290px;
      margin-top: 15px;
    }
  }

  &__button {
    color: #000;
    border-color: #2196f3;
    background-color: white;
    min-width: 106px;
    @media (max-width: $size-md) {
      flex-grow: 1;
      width: 100%;
      font-weight: bold;
    }

    &:hover {
      color: #000;
    }
    &:disabled {
      color: #000;
      opacity: 0.5;
    }
  }
  &__download {
    color: black !important;
    @media (max-width: $size-md) {
      order: 2;
    }
  }

  &__wrapper:nth-child(odd) {
    @media (max-width: $size-md) {
      background-color: rgba(0, 30, 83, 0.05);
    }
  }

  &__agreementWrapper {
    display: flex;
    flex-direction: column;
    background-color: #f6f9ff;
  }
}

.buttonContainer {
  display: flex;
  width: 100%;
  justify-content: end;
  padding: 1rem;
}

.buttonSubmit {
  width: auto;
}

@media screen and (max-width: $size-sm) {
  .buttonContainer {
    justify-content: center;
  }
  .buttonSubmit {
    width: 100%;
  }
}

.rotateimg180 {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}
